import { RateSelectionReasonType } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'rate-selection-reason-type';

export class RateSelectionReasonController extends BaseHttpController {
  constructor() {
    super(endpoint, { canIncludeSubDomains: true });
  }

  async findAllTypes(): Promise<RateSelectionReasonType[]> {
    const response = await this.http.get<RateSelectionReasonType[]>('');
    return response.data.map((val) => new RateSelectionReasonType(val));
  }

  async isRateSelectionReasonRequired(clientId: number): Promise<boolean> {
    const response = await this.http.get<boolean>(
      `reason-required/${clientId}`,
    );
    return response.data;
  }
}
